// import React from "react";
// import yasa_logo from "../assets/yasaApp.png"
// export default function Navbar() {
//   return (
//     <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm py-3 font-face">
//       <div className="container">
//         {/* <a className="navbar-brand fw-bold text-success" href="#">
//           YASA
//         </a> */}
//         <img src={yasa_logo} alt="App Preview"  className="navbar-brand" style={{width:100}}/>

//         <button
//           className="navbar-toggler"
//           type="button"
//           data-bs-toggle="collapse"
//           data-bs-target="#nav"
//         >
//           <span className="navbar-toggler-icon"></span>
//         </button>

//         <div className="collapse navbar-collapse" id="nav">
//           <ul className="navbar-nav ms-auto">
//             <li className="nav-item">
//               <a className="nav-link " href="#about">دەربارەی ئێمە</a>
//             </li>
//             <li className="nav-item">
//               <a className="btn btn-success ms-lg-3" href="#download">
//                 ئەندامبوون
//               </a>
//             </li>
//           </ul>
//         </div>
//       </div>
//     </nav>
//   );
// }

// import yasa_logo from "../assets/yasaApp.png"
// import React from "react";
// import { Link } from "react-router-dom";

// export default function Navbar() {
//   return (
//     <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm py-3">
//       <div className="container">

//         <Link className="navbar-brand fw-bold text-success" to="/">
//            <img src={yasa_logo} alt="App Preview"  className="navbar-brand" style={{width:100}}/>
//         </Link>

//         <button
//           className="navbar-toggler"
//           type="button"
//           data-bs-toggle="collapse"
//           data-bs-target="#nav"
//         >
//           <span className="navbar-toggler-icon"></span>
//         </button>

//         <div className="collapse navbar-collapse" id="nav">
//           <ul className="navbar-nav ms-auto">

//             <li className="nav-item">
//               <Link className="nav-link" to="/">
//                 دەربارەی ئێمە
//               </Link>
//             </li>

//             <li className="nav-item">
//               <Link className="btn btn-success ms-lg-3" to="/join">
//                 ئەندامبوون
//               </Link>
//             </li>

//           </ul>
//         </div>
//       </div>
//     </nav>
//   );
// }

import yasa_logo from "../assets/yasaApp.png";
import React from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <nav className="navbar bg-white shadow-sm py-3">
      <div className="container d-flex align-items-center justify-content-between">

        {/* LOGO - LEFT */}
        <Link className="navbar-brand m-0" to="/">
          <img
            src={yasa_logo}
            alt="App Preview"
            style={{ width: 100 }}
          />
        </Link>

        {/* BUTTONS - RIGHT */}
        <ul className="navbar-nav d-flex flex-row align-items-center gap-3 m-0">

          <li className="nav-item">
            <Link className="nav-link p-0" to="/">
              دەربارەی ئێمە
            </Link>
          </li>

          <li className="nav-item">
            <Link className="btn btn-success btn-sm" to="/join">
              ئەندامبوون
            </Link>
          </li>

        </ul>

      </div>
    </nav>
  );
}
